export const fileStatus = {
  UPLOAD: "UPLOAD",
  DOWNLOAD: "DOWNLOAD",
  ERROR: "ERROR",
  OK: "OK",
};
